import { StudentData } from './types';

interface SearchIndex {
  [key: string]: {
    text: string;
    studentId: string;
  };
}

let searchIndex: SearchIndex | null = null;

export const loadSearchIndex = async (): Promise<void> => {
  try {
    const response = await fetch('/resume_search_index.json');
    searchIndex = await response.json();
  } catch (error) {
    console.error('Error loading search index:', error);
    searchIndex = {};
  }
};

export const searchResumes = (query: string, students: StudentData[]): StudentData[] => {
  if (!searchIndex) {
    console.warn('Search index not loaded');
    return [];
  }

  // Convert query to lowercase and split into terms
  const terms = query.toLowerCase().split(/\s+/);
  
  // Create a set of student IDs that match the search
  const matchingStudentIds = new Set<string>();
  
  // Search through the index
  Object.entries(searchIndex).forEach(([studentId, data]) => {
    const text = data.text.toLowerCase();
    
    // Check if all terms are present (AND logic)
    const allTermsMatch = terms.every(term => text.includes(term));
    
    if (allTermsMatch) {
      matchingStudentIds.add(studentId);
    }
  });
  
  // Return matching students
  return students.filter(student => matchingStudentIds.has(student.Internal_ID));
};

// Helper function to create the search index (run this once on the server)
export const createSearchIndex = async (): Promise<void> => {
  // This function would be implemented on the server side
  // For now, we'll just create an empty index
  const searchIndex: SearchIndex = {};
  
  // In a real implementation, this would:
  // 1. Read all PDFs from the byid folder
  // 2. Extract text from each PDF
  // 3. Create a search index
  // 4. Save the index to resume_search_index.json
}; 